import { FieldRenderProps } from 'react-final-form';
import Select, { GroupBase, Props as ReactSelectProps } from 'react-select';

import { CustomStyles, CustomTheme } from './styles';

export type Props<
  Option,
  FieldValue = Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
> = ReactSelectProps<Option, IsMulti, Group> &
  FieldRenderProps<FieldValue, HTMLElement, Option> & { labelText: string };

export default function TableFilterReactSelect<
  Option,
  FieldValue = Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>({
  input,
  labelText,
  styles,
  ...rest
}: Props<Option, FieldValue, IsMulti, Group>) {
  // Handle onChange to immediately update the field value
  const handleChange = (value: Option | readonly Option[] | null) => {
    input.onChange(value as FieldValue);
    // Ensure the field is marked as touched to trigger immediate update
    if (input.onBlur) {
      input.onBlur();
    }
  };

  return (
    <div className="relative">
      <label
        htmlFor={input.name}
        className="absolute -top-2 left-2 z-10 inline-block bg-[linear-gradient(to_bottom,_var(--tw-gradient-stops))] from-gray-50 to-white px-1 text-xs font-medium text-gray-900"
      >
        {labelText || input.name}
      </label>
      <Select
        theme={CustomTheme}
        styles={styles || CustomStyles}
        inputId={input.name}
        {...rest}
        {...input}
        onChange={handleChange}
        value={input.value}
      />
    </div>
  );
}
